import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { RULE_ARITHMETIC_FUNCTION_TYPES } from 'yeself-common/enum/RuleEnum';

import SelectField from '../../components/SelectField';
import PlainStringField from '../../components/PlainStringField';

import { FacesGuideRuleValues } from '../types';

type FacesGuideRuleFieldProps = {
    value: FacesGuideRuleValues;
    onChange: (value: FacesGuideRuleValues) => void;
};

const FacesGuideRuleField = ({ value, onChange }: FacesGuideRuleFieldProps): React.ReactElement => {
    const [levelValue, setLevelValue] = useState({
        level0: value.level?.[0]?.data.key || null,
        level1: value.level?.[1]?.data.value || null,
    });

    const handleOnChange = useCallback(
        (index: number) => (newValue) => {
            const newLevelValue = { ...levelValue, [`level${index}`]: newValue };

            const level: FacesGuideRuleFieldProps['value']['level'] = [
                newLevelValue.level0 ? { data: { key: newLevelValue.level0 } } : undefined,
                newLevelValue.level1 ? { data: { value: newLevelValue.level1 } } : undefined,
            ];

            setLevelValue(newLevelValue);
            onChange({ ...value, level });
        },
        [levelValue, onChange, value]
    );

    return (
        <>
            <SelectField
                autoWidth
                options={[
                    {
                        label: <FormattedMessage id="Rules.level.after" />,
                        value: RULE_ARITHMETIC_FUNCTION_TYPES.GT,
                    },
                    {
                        label: <FormattedMessage id="Rules.level.afterOrEqual" />,
                        value: RULE_ARITHMETIC_FUNCTION_TYPES.GE,
                    },
                    {
                        label: <FormattedMessage id="Rules.level.before" />,
                        value: RULE_ARITHMETIC_FUNCTION_TYPES.LT,
                    },
                    {
                        label: <FormattedMessage id="Rules.level.beforeOrEqual" />,
                        value: RULE_ARITHMETIC_FUNCTION_TYPES.LE,
                    },
                    {
                        label: <FormattedMessage id="Rules.level.on" />,
                        value: RULE_ARITHMETIC_FUNCTION_TYPES.EQ,
                    },
                ]}
                value={levelValue.level0 || ''}
                onChange={handleOnChange(0)}
            />
            {levelValue.level0 ? (
                <PlainStringField
                    type="date"
                    value={levelValue.level1 || ''}
                    onChange={handleOnChange(1)}
                />
            ) : null}
        </>
    );
};

export default FacesGuideRuleField;
